__turbopack_context__.v({
  "wrapper": "rv2Smq_wrapper",
});
